import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

import { getAutoImportErrorData } from '../../constants/errorsMapping.js';
import { useDataFileLocalStorage } from '../../hooks/useLocalStorage.js';

type AutoImportErrorAlertProps = {
  error: string;
};

export const AutoImportErrorAlert = ({ error }: AutoImportErrorAlertProps) => {
  const [isAlertClosed, setIsAlertClosed] = useDataFileLocalStorage<boolean>(
    'isAutoImportErrorAlertClosed',
    { initialValue: false },
  );

  const { t } = useTranslation('@myn/import-hub');
  const { title, message } = getAutoImportErrorData(t, error);

  if (isAlertClosed) {
    return null;
  }

  return (
    <Alert
      title={title}
      description={message}
      severity="error"
      variant="inline"
      removable
      onClose={() => setIsAlertClosed(true)}
      className="mb-6"
    />
  );
};
